// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  showTanks: 6,
  googleApiKey: 'AIzaSyDDLWk9mUaqerZZaQgeqka0De2vU2XXLX8',
  documentationUrl: 'https://docs.knapphus.net/',
  // MIDLERTIDIG (kun dev): simuler Visma Val21 = 1 (ADMIN-modultilgang) til ny
  // Connect API med modul 104 er ute på staging. Rollen Administrator kreves fortsatt.
  // Finnes ikke i environment.prod.ts, så prod-bygg er upåvirket. Fjern før merge.
  simulateAdminModule: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
